import React, { useEffect,useState } from "react";
import { useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";

import { Link, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Grid,
  CircularProgress,
  Tabs,
  Tab,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import TabPanel from "../../components/TabPanel";
import LinesTable from "./journal/lines.table";
import RelatedRecordsHeader from "./journal/related.records.header";
import SystemInformationHeader from "./journal/system.information.header";
import CustomHeader from "./journal/custom.header";
import EftHeader from "./journal/eft.header";
import { getJournalTransactionDetail } from "../../api/journal";
import {
  GridComp12,
  GridComp4,
  GridComp6,
} from "../../components/GridComponents";
import JournalCommunication from "./journal/communication.header";
import { CustomCheckBox } from "../../components/CheckboxComp";

export default function TransactionTypeJournal() {
  const snackbar = useSnackbar();
  const [loading, setLoading] = useState(false);
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [rowData, setRowData] = useState([]);

  /*----------------Tabs-----------------*/
  const [tabIndex, setTabIndex] = useState(0);
  /*----------------End Tabs-----------------*/

  useEffect(() => {
    if (user.token) {
      getTransactionDocDetailTableData();
    }
    return;
  }, []);

  async function getTransactionDocDetailTableData() {
    setLoading(true);
    try {
      const { data } = await getJournalTransactionDetail(user.token, {
        tranid: params.docNo,
      });
      setRowData(data.data.details[0]);
      setLoading(false);
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      setLoading(false);
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  return loading ? (
    <>
      <Typography component="h4" fontWeight={500} className="pageTitle">
        Journal
      </Typography>
      <Typography component="p" sx={{ mb: 2 }}></Typography>

      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" variant="contained" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Foreign Currency
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            APPROVAL
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        ></Box>
        <Box className="viewDetilsBox">
          <Grid container className="mb-2">
            <Grid item xs={12}>
              <p
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress></CircularProgress>
              </p>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  ) : (
    <>
      <Typography component="h4" fontWeight={500} className="pageTitle">
        Journal
      </Typography>
      <Typography component="p" style={{ margin: 4 }}>
        <span className="para-no" style={{ marginRight: 4 }}>
          <strong>{rowData?.tranid}</strong>
        </span>
        <Button className="blue-button" size="small" sx={{ margin: "4px" }}>
          {rowData?.status}
        </Button>
      </Typography>
      {/*Primary Information*/}

      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Primary Information
          </Typography>
          <Link to={"/transaction-type/" + params.slug}>
            <Button size="small" variant="contained" className="backBtn">
              Go Back
            </Button>
          </Link>
        </Box>
        <Box className="viewDetilsBox">
          
          <>
            <Grid container className="mb-2">
              <GridComp6 title={"ENTRY NO."} data={rowData.entry_no} />
              <GridComp6 title={"MEMO"} data={rowData.memo} />
              <GridComp6 title={"SUBSIDIARY"} data={rowData.subsidiary} />
              <GridComp6 title={"REVERSAL #"} data={rowData.reversal_number} />

              <GridComp6 title={"PC/PROJECT"} data={rowData.pc_project} />
              <GridComp6 title={"DATE"} data={rowData.date} />
              <GridComp6 title={"REVERSAL DATE"} data={rowData.reversal_date} />

              <GridComp6
                title={"POSTING PERIOD"}
                data={rowData.posting_period}
              />

              <GridComp6
                title={"RELATED JOURNAL ENTRY"}
                data={rowData.related_journal_entry}
              />
            </Grid>
          </>
        </Box>
      </Box>
      {/*foreign currency*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            Foreign Currency
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <>
            <Grid container className="mb-2">
              <GridComp6 title={"EXCHANGE RATE"} data={rowData.exchange_rate} />
              <GridComp6 title={"CURRENCY"} data={rowData.currency} />
            </Grid>
          </>
        </Box>
      </Box>
      {/*approval*/}
      <Box className="viewBox">
        <Box
          className="headerItems"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          pb={2}
        >
          <Typography component="h5" fontWeight={500} className="pageHeading1">
            APPROVAL
          </Typography>
        </Box>
        <Box className="viewDetilsBox">
          <>
            <Grid container className="mb-2">
              <GridComp6 title={"NEXT APPROVER"} data={rowData.nextapprover} />
              <GridComp6 title={"APPROVER"} data={rowData.approver} />
              <GridComp6
                title={"APPROVAL STATUS"}
                data={rowData.approval_status}
              />
              <Grid item xs={12} sm={6} md={4} className="m-b-10">
                {(!rowData.nextapprover || rowData.nextapprover === "") &&
                (!rowData.approver || rowData.approver === "") && (
                  
                  <div
                    style={{
                      backgroundColor: "yellow",
                      padding: "10px",
                      border: "1px solid #ccc",
                    }}
                  >
                    <p className="tFormlabel">AUTO APPROVED</p>
                  </div>
                )}
              </Grid>

              <CustomCheckBox
                title={"MIGRATION CASH/COIN"}
                data={rowData.migration_cash_coin}
              />
            </Grid>
          </>
        </Box>
      </Box>
    
      <Box>
        <Box
          className="viewBox "
          // sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: "#fff" }}
        >
          <Tabs
                     value={tabIndex}
                     onChange={(e, nv) => {
                       setTabIndex(nv);
                     }}
                     variant="scrollable"
                     scrollButtons="auto"
                     aria-label="scrollable auto tabs example"
                     className="tabs-bkg"
                   >
            <Tab label="Lines" />
            <Tab label="Communication" />
            <Tab label="Related Records" />
            <Tab label="System Information" />
            <Tab label="Custom" />
            <Tab label="EFT" />
            {/* <Tab label="Approval History" /> */}
          </Tabs>
          {/*Lines*/}
          <TabPanel value={tabIndex} index={0}>
            <Box className="viewDetilsBox">
              <LinesTable></LinesTable>
            </Box>
          </TabPanel>
          {/*Lines*/}
          {/* Communication */}
          <TabPanel value={tabIndex} index={1}>
            {tabIndex === 1 && (
              <JournalCommunication tabIndexP={tabIndex}></JournalCommunication>
            )}
          </TabPanel>
          {/* Communication */}
          {/* Related Records */}
          <TabPanel value={tabIndex} index={2}>
            <Box className="viewDetilsBox">
              {tabIndex === 2 && (
                <RelatedRecordsHeader
                  tabIndexP={tabIndex}
                ></RelatedRecordsHeader>
              )}
            </Box>
          </TabPanel>
          {/* Related Records */}
          {/* System Information */}
          <TabPanel value={tabIndex} index={3}>
            <Box className="viewDetilsBox">
              {tabIndex === 3 && (
                <SystemInformationHeader></SystemInformationHeader>
              )}
            </Box>
          </TabPanel>
          {/* System Information */}
          {/* Custom */}
          <TabPanel value={tabIndex} index={4}>
            <Box className="viewDetilsBox">
              {tabIndex === 4 && (
                <CustomHeader tabIndexP={tabIndex}></CustomHeader>
              )}
            </Box>
          </TabPanel>
          {/* Custom */}
          {/* CostData */}
          <TabPanel value={tabIndex} index={5}>
            <Box className="viewDetilsBox">
              {tabIndex === 5 && <EftHeader tabIndexP={tabIndex}></EftHeader>}
            </Box>
          </TabPanel>
          {/* AprovalHistory */}
          {/* <TabPanel value={tabIndex} index={6}>
            <Box className="viewDetilsBox">
              <AprovalHistory tabIndexP={tabIndex}></AprovalHistory>
            </Box>
          </TabPanel> */}
        </Box>
      </Box>
    </>
  );
}
